import React from 'react';

/** Energy Dial marker from the pack: one wave = low, two = steady, three = high. */
export function EnergyWaves({
  count,
  className = ''
}: {
  count: 1 | 2 | 3;
  className?: string;
}) {
  return <svg viewBox="0 0 32 24" className={`h-5 w-7 ${className}`} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true" data-id="element-85" data-mp="2y3hcxz29mdyt">
      {Array.from({
      length: count
    }).map((_, i) => {
      const y = count === 1 ? 12 : count === 2 ? 8 + i * 8 : 5 + i * 7;
      return <path key={i} d={`M3 ${y} q 4.5 -5 9 0 t 9 0 t 9 0`} data-id="element-86" data-mp="32402fmgor7xu" data-mpi={i} />;
    })}
    </svg>;
}